import { BOOKING_ADD_ONS, type BookingAddOnDefinition } from '@/lib/pricing/addOnsCatalog';
import type { ServiceType } from '@/types/bookingFlow';

export { BOOKING_ADD_ONS };
export type { BookingAddOnDefinition };

export function filterAddOnsForService(
  serviceType: ServiceType,
  addOns: BookingAddOnDefinition[] = BOOKING_ADD_ONS,
) {
  return addOns.filter(addOn => {
    if (addOn.excludedServices?.includes(serviceType)) {
      return false;
    }

    if (addOn.applicableServices && !addOn.applicableServices.includes(serviceType)) {
      return false;
    }

    return true;
  });
}
